import { render } from "./PolicySummary.vue?vue&type=template&id=41559814&scoped=true&ts=true"
import script from "./PolicySummary.vue?vue&type=script&lang=ts"
export * from "./PolicySummary.vue?vue&type=script&lang=ts"

import "./PolicySummary.vue?vue&type=style&index=0&id=41559814&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41559814"],['__file',"src/components/PolicySummary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41559814"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41559814', __exports__)) {
    api.reload('41559814', __exports__)
  }
  
  module.hot.accept("./PolicySummary.vue?vue&type=template&id=41559814&scoped=true&ts=true", () => {
    api.rerender('41559814', render)
  })

}


export default __exports__